{
  "eyebrow": "Créez votre compte",
  "title": "Quelques informations sur votre entreprise.",
  "sub": "Vous serez l'administrateur principal. Vous pourrez inviter d'autres administrateurs plus tard.",
  "company": "Entreprise",
  "companyName": "Nom de l'entreprise",
  "companyVat": "Numéro de TVA",
  "companyVatBssHint": "Requis pour les déclarations à la Sécurité sociale belge (DIMONA).",
  "companyCountry": "Pays",
  "admin": "Administrateur principal",
  "adminFirst": "Prénom",
  "adminLast": "Nom",
  "adminEmail": "E-mail professionnel",
  "adminPhone": "Téléphone",
  "adminPw": "Mot de passe",
  "adminPwHint": "Au moins 10 caractères, dont un chiffre.",
  "adminPwShow": "Afficher le mot de passe",
  "adminPwHide": "Masquer le mot de passe",
  "terms": {
    "pre": "J'accepte les",
    "t": "Conditions d'utilisation",
    "and": "et la",
    "p": "Politique de confidentialité"
  },
  "cta": "Créer le compte & continuer",
  "errors": {
    "required": "Obligatoire",
    "tooShort": "Trop court",
    "invalidEmail": "Saisissez un e-mail valide",
    "invalidVat": "Saisissez un numéro de TVA valide",
    "invalidBelgianVat": "Saisissez un numéro de TVA belge valide (par ex. BE0123456789).",
    "invalidPhone": "Saisissez un numéro de téléphone valide",
    "passwordWeak": "Au moins 10 caractères, dont un chiffre",
    "termsRequired": "Vous devez accepter les conditions",
    "emailExists": "Cet e-mail est déjà utilisé",
    "vatRequiredForBss": "TVA requise pour la Sécurité sociale belge",
    "network": "Erreur réseau ou serveur. Réessayez."
  },
  "verify": {
    "awaitingTitle": "Vérifiez votre boîte de réception",
    "awaitingSub": "Nous avons envoyé un lien de vérification à {{email}}. Cliquez dessus pour activer votre compte et démarrer votre essai gratuit.",
    "resend": "Renvoyer l'e-mail",
    "resendCooldown": "Renvoyer dans {{seconds}}s",
    "verifyingTitle": "Vérification…",
    "successTitle": "Votre essai gratuit de 30 jours a commencé !",
    "successSub": "Aucune carte bancaire requise. Connectez-vous à votre tableau de bord pour commencer à utiliser Done-it.",
    "errorTitle": "Impossible de vérifier ce lien",
    "errorSub": "Le lien a peut-être expiré. Recommencez à partir de vos coordonnées de compte.",
    "errorCta": "Retour au compte",
    "interstitial": "Vérification de l'e-mail",
    "subscribedTitle": "Votre compte est prêt",
    "subscribedSub": "Le paiement est déjà terminé. Connectez-vous au tableau de bord pour commencer à utiliser Done-it.",
    "subscribedCta": "Se connecter au tableau de bord",
    "successCta": "Ouvrir le tableau de bord",
    "successNote": "Vous recevrez quelques e-mails utiles pendant votre essai, et un lien pour vous abonner vers la fin.",
    "awaitingSubFree": "Nous avons envoyé un lien de vérification à {{email}}. Cliquez dessus pour activer votre compte gratuit — Time Zero est gratuit pour toujours, sans carte bancaire.",
    "successTitleFree": "Votre compte gratuit est prêt !",
    "successNoteFree": "Time Zero est gratuit pour toujours dans la limite de ses quotas. Passez à une offre supérieure à tout moment pour un usage illimité."
  }
}
